import React, { useEffect } from "react";
import axios from 'axios';
import { useSearchParams, useNavigate, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from "../context/AuthProvider";
import { BASE_URL } from "../constant";

const PrivateRoute = () => {
  const { userEmail, token } = useAuth();
  const [ searchParams ] = useSearchParams();
  const navigate = useNavigate();
  const campaignType = searchParams.get('campaign');
  const destination = searchParams.get('destination');
  const email = searchParams.get('email');

  const auditUser = async () => {
    try {
        await axios.post(BASE_URL+'/auditUser', {
            campaignType,
            destination,
            email
        }, {
            headers: {
                "Content-Type": "application/json",
            }
        });

        navigate(window.location.pathname, { replace: true });
    } catch (err) {
        console.error("API error:", err);
    }
  };

  useEffect(() => {
      if(!userEmail && (campaignType && destination && email)) {
          auditUser();
      }
  }, [campaignType, destination, email]);

  if (!token) return <Navigate to="/sign-in" />;

  return <Outlet />;
};

export default PrivateRoute;